import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { useAccordionItemContext } from './AccordionItem.js';
import { Box } from '../Box/index.js';
import { Divider } from '../Divider/index.js';
import { AccordionIcon } from './AccordionIcon.js';

/* ======================================= */
/**
 * @deprecated Please use AccordionHeaderAlpha instead of AccordionHeader moving forward. AccordionHeader will be deprecated in future major releases.
 *
 * ---
 * Accordion allows users to expand one or more panels at a time, revealing information
within a small space.
 *
 * _Note_: AccordionHeader and AccordionPanels have default padding of 'lg', which can be overridden.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/accordion#usage)
 * - [Props](https://blockparty.endpoint.com/components/accordion#props)
 * <br />
 *
 */
const AccordionHeader = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    onClick,
    iconLeft,
    iconRight,
    hideDivider,
    dataTestId = 'accordion-header',
    ...props
  } = _ref;
  const {
    collapsed,
    setCollapsed,
    isDisabled,
    headerId,
    panelId
  } = useAccordionItemContext();
  const toggle = () => {
    setCollapsed(!collapsed);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    _focusVisible: {
      boxShadow: 'focusInset'
    },
    "aria-controls": panelId,
    "aria-disabled": isDisabled,
    "aria-expanded": collapsed,
    as: "button",
    backgroundColor: "white",
    border: "none",
    borderRadius: "radiusDefault",
    cursor: "pointer",
    "data-test-id": dataTestId
    // @ts-ignore
    ,
    disabled: isDisabled,
    display: "flex",
    id: headerId,
    justifyContent: iconRight ? 'space-between' : 'initial',
    m: "space0",
    outline: "none",
    px: "space30",
    py: "space50",
    textAlign: "left",
    transition: "fast",
    transitionProperty: "background-color, box-shadow",
    type: "button",
    width: "100%",
    onClick: e => {
      e.stopPropagation();
      toggle();
      onClick && onClick(e);
    }
  }, props), iconLeft && /*#__PURE__*/React__default.createElement(AccordionIcon, {
    collapsed: collapsed,
    mr: "space30",
    name: "ArrowCarrotRight"
  }), children, iconRight && /*#__PURE__*/React__default.createElement(AccordionIcon, {
    collapsed: collapsed,
    ml: "space30",
    name: "ArrowCarrotDown"
  })), !hideDivider && collapsed && /*#__PURE__*/React__default.createElement(Divider, null));
});
AccordionHeader.displayName = 'AccordionHeader';

export { AccordionHeader };
